import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { detect } from 'detect-browser';
import { TransitionGroup } from 'react-transition-group';

import { connect } from 'react-redux';
import { css } from 'glamor';
import ImageLoader from 'react-load-image';

import './background.css';

import changeToDevice from '../actions/change-to-device';
import fetchGroup from '../actions/fetch-group';
import trackStepView from '../actions/track-step-view';
import trackStepCompletion from '../actions/track-step-completion';

import Button from '../components/button';

import { BASE_FONT_FAMILY } from '../design/';
import { PRIMARY, WHITE } from '../design/palette';
import { mobile, tablet } from '../design/media-queries';

import withDynamicContent from '../utils/dynamic-content';

import { LANDING_STEP } from '../steps';

const browser = detect();
const fixtLogo = require('./logo.png');

const detectedBrowser = () => {
  return browser.name === 'ie' ? subheadingIE : subheading;
};

const formatPhoneNumber = (phoneNumber = '') =>
  `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(
    6
  )}`;

class Landing extends Component {
  constructor(props) {
    super(props);

    const dynamicContentDictionary = props.getDynamicContent(
      props.match.params.groupSlug
    );

    this.state = { currentImgIndex: 0, dynamicContentDictionary };
  }

  UNSAFE_componentWillMount() {
    const {
      params: { groupSlug },
    } = this.props.match;

    if (groupSlug) {
      this.props.fetchGroup(groupSlug);
    }

    this.props.trackStepView({ step: LANDING_STEP });
  }

  componentDidMount() {
    this.imgRotater = setInterval(this.nextImage, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.imgRotater);
  }

  nextStep = () => {
    this.props.trackStepCompletion({ step: LANDING_STEP });
    this.props.changeToDevice();
  };

  nextImage = () => {
    const { currentImgIndex, dynamicContentDictionary } = this.state;
    this.setState({
      currentImgIndex:
        (currentImgIndex + 1) %
        dynamicContentDictionary.backgroundImagePaths.length,
    });
  };

  render() {
    const { accountLogo, groupLogo, loadingGroup } = this.props;
    const { dynamicContentDictionary } = this.state;
    const landingLogo = accountLogo || fixtLogo;

    return (
      <div {...styles.routeContainer}>
        <Background
          currentImgIndex={this.state.currentImgIndex}
          imageUrls={dynamicContentDictionary.backgroundImagePaths}
        />

        <div {...styles.logoContainer}>
          <div {...styles.imgContainer}>
            {loadingGroup || (
              <img {...styles.fixtLogo} alt="Landing Logo" src={landingLogo} />
            )}

            {groupLogo && (
              <img {...styles.partnerLogo} alt="Group Logo" src={groupLogo} />
            )}
          </div>
        </div>

        <div {...styles.mainContainer}>
          <div {...styles.mainContent}>
            <TransitionGroup timeout={{ enter: 200, exit: 200 }}>
              <div {...styles.heading}>
                <span {...styles.headingFocus}>On Demand</span>{' '}
                {dynamicContentDictionary.serviceType}
              </div>
            </TransitionGroup>

            <TransitionGroup timeout={{ enter: 200, exit: 200 }}>
              <div {...styles.subheading}>
                Our certified technicians will come to your location,
                <br />
                {dynamicContentDictionary.serviceAction} fast, and get you&nbsp;
                {dynamicContentDictionary.actionResult}
              </div>
            </TransitionGroup>

            <div {...styles.button}>
              <Button name="start" onClick={this.nextStep} step={LANDING_STEP}>
                <span {...styles.buttonText}>Book a Service</span>
              </Button>
            </div>
          </div>
        </div>
        <footer {...styles.footer}>
          <div {...styles.footerContent}>
            {accountLogo && (
              <div {...styles.poweredByContainer}>
                <span {...styles.poweredByText}>Powered by </span>

                <img {...styles.poweredByImg} alt="Fixt Logo" src={fixtLogo} />
              </div>
            )}
            <span {...styles.whiteText}>
              Have any questions or need help? <br />
              {dynamicContentDictionary.contactVerbiage} at&nbsp;
              {dynamicContentDictionary.showContactEmail && (
                <React.Fragment>
                  <a {...styles.link} href="mailto:info@fixt.co">
                    info@fixt.co
                  </a>
                  <span>&nbsp;or&nbsp;</span>
                </React.Fragment>
              )}
              <a
                {...styles.link}
                href={`tel:+1${dynamicContentDictionary.contactNumber}`}
              >
                {formatPhoneNumber(dynamicContentDictionary.contactNumber)}
              </a>
            </span>
          </div>
        </footer>
      </div>
    );
  }
}

Landing.propTypes = {
  partnerLogo: PropTypes.string,
};

const Preloader = () => <div />;

function Background({ currentImgIndex, imageUrls }) {
  return (
    <TransitionGroup timeout={{ enter: 100, exit: 500 }}>
      {imageUrls.map((imgUrl, i) => {
        if (currentImgIndex === i) {
          return (
            <ImageLoader key={`background-image-${i}`} src={imgUrl}>
              <img {...styles.backgroundImageStyle} alt="Fixt Background" />
              <Preloader />
              <Preloader />
            </ImageLoader>
          );
        } else {
          return null;
        }
      })}
    </TransitionGroup>
  );
}

const subheading = css({
  textAlign: 'center',
  fontSize: '1.313em',
  margin: 0,
  width: '100%',
  lineHeight: '1.875em',
  fontWeight: 300,
  opacity: '0.8',
  [mobile]: {
    fontSize: '0.9em',
  },
});

const subheadingIE = css({
  textAlign: 'center',
  fontSize: '1.313em',
  margin: 'auto',
  width: '65%',
  lineHeight: '1.875em',
  fontWeight: 300,
  opacity: '0.8',
  [mobile]: {
    fontSize: '0.9em',
  },
});

const subheadingStyle = browser ? detectedBrowser() : subheading;

const styles = {
  backgroundImageStyle: css({
    objectFit: 'cover',
    objectPosition: 'center center',
    height: '100%',
    width: '100%',
    zIndex: -99,
    position: 'absolute',
    left: 0,
    top: 0,
  }),
  fixtLogo: css({
    height: '3em',
    [mobile]: {
      height: '2em',
    },
  }),
  routeContainer: css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  }),
  placeholder: css({
    display: 'none',
    overflow: 'hidden',
  }),
  logoContainer: css({
    flex: 1,
  }),
  imgContainer: css({
    paddingTop: '1.5em',
    paddingLeft: '5%',
  }),
  partnerLogo: css({
    height: '3em',
    marginLeft: '1%',
    [mobile]: {
      height: '2em',
    },
    '[src^="/logos/original/missing"]': {
      display: 'none',
    },
  }),
  mainContainer: css({
    flex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    color: WHITE,
    textAlign: 'center',
  }),
  heading: css({
    fontSize: '2.875em',
    fontWeight: 100,
    marginBottom: '0.5em',
    [mobile]: {
      fontSize: '1.5em',
    },
  }),
  headingFocus: css({
    fontWeight: 900,
  }),
  subheading: subheadingStyle,
  button: css({
    margin: '5em auto',
    width: '35%',
    [mobile]: {
      width: '50%',
      marginTop: '2em',
    },
    [tablet]: {
      width: '50%',
    },
  }),
  buttonText: css({
    fontSize: '0.9em',
    margin: 0,
    padding: '0.3em 0em',
    textAlign: 'center',
    [mobile]: {
      fontSize: '0.6em',
    },
  }),
  footer: css({
    flex: 1,
    width: '100%',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'flex-end',
    display: 'flex',
  }),
  footerContent: css({
    paddingBottom: '1em',
  }),
  poweredByContainer: css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: WHITE,
    marginBottom: 10,
  }),
  poweredByText: css({
    marginRight: 5,
  }),
  poweredByImg: css({
    height: '1.5em',
  }),
  link: css({
    color: PRIMARY,
    fontFamily: BASE_FONT_FAMILY,
    textDecoration: 'none',
    '.shouldhover &:hover': {
      color: PRIMARY,
    },
  }),
  whiteText: css({
    color: 'white',
  }),
};

const selectActions = {
  changeToDevice,
  fetchGroup,
  trackStepCompletion,
  trackStepView,
};

const selectState = ({
  group: { accountLogo, accountAlternateLogo, alternateLogo, logo, loading },
}) => ({
  accountLogo: accountAlternateLogo || accountLogo,
  groupLogo: alternateLogo || logo,
  loadingGroup: loading,
});

export default connect(
  selectState,
  selectActions
)(withDynamicContent(Landing, 'landing'));
